const problem = [
    {
        path: '/problem/:id',
        name: 'problemDetail',
        component: () => import('@/view/problem/Detail'),
        meta: {
            requireAuth: true
        }
    }
]
export default problem
